import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeavePatientAddressesPicker from './CSSZSickLeavePatientAddressesPicker';
import { CsszPatientAddressRow } from '../../Helpers/csszRegistryPatientAddresses.helper';

interface Props extends BaseModalProps {
	userId: string;
	onSelect: (item: CsszPatientAddressRow) => void;
}

const NESTED_MODAL_Z_INDEX = 1060;

const CSSZSickLeavePatientAddressesPickerModal: React.FC<Props> = ({
	modalStyle,
	...props
}) => {
	return (
		<BaseModal
			{...props}
			modalStyle={{ zIndex: NESTED_MODAL_Z_INDEX, ...modalStyle }}
			title='component.CSSZSickLeavePatientAddress.pickerModalTitle'>
			<CSSZSickLeavePatientAddressesPicker
				userId={props.userId}
				onSelect={props.onSelect}
				onClose={props.onClose}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeavePatientAddressesPickerModal;
